module.exports = __webpack_public_path__ + "assets/printed-food-d3448b1f122a0b94aab02dd2b5a0333f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/printed-food.jpg
// module id = 523
// module chunks = 1